import { Identifiable, List, Milestone, Task, Event } from "@planzone/dto";

interface Props {
  list: Identifiable<List> & { elementsNumber: number };
  isOpen?: boolean;
  depth?: number;
}

enum Elements {
  LIST,
  TASK,
  MILESTONE,
  EVENT,
}

type MappedElement =
  | {
      type: Elements.LIST;
      data: Identifiable<List> & { elementsNumber: number } & { rank: number };
    }
  | { type: Elements.TASK; data: Identifiable<Task> & { rank: number } }
  | {
      type: Elements.MILESTONE;
      data: Identifiable<Milestone> & { rank: number };
    }
  | {
      type: Elements.EVENT;
      data: Identifiable<Event> & { rank: number };
    };

export type { Props, MappedElement };

export { Elements };
